/**
 * Conditional logging system - only logs in development or when forced
 */
const isDev = import.meta.env.DEV;
const forceDebug = import.meta.env.VITE_FORCE_DEBUG === 'true';
const shouldLog = isDev || forceDebug;

export const logger = {
    log: (...args: any[]) => shouldLog && console.log(...args),
    warn: (...args: any[]) => shouldLog && console.warn(...args),
    error: (...args: any[]) => console.error(...args), // Always log errors
    info: (...args: any[]) => shouldLog && console.info(...args),
    debug: (...args: any[]) => shouldLog && console.debug(...args),
    prod: (...args: any[]) => console.log('[PROD]', ...args), // Production-specific logs
};

export default logger;
